import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/nl.ts
var add = "Toevoegen";
var remove = "Verwijderen";
var removeAll = "Alles verwijderen";
var incomplete = "Sorry, niet alle velden zijn correct ingevuld.";
var submit = "Versturen";
var noFiles = "Geen bestand gekozen";
var moveUp = "Naar boven gaan";
var moveDown = "Naar beneden verplaatsen";
var isLoading = "Aan het laden...";
var loadMore = "Meer laden";
var next = "Vervolgens";
var prev = "Voorgaand";
var addAllValues = "Alle waarden toevoegen";
var addSelectedValues = "Geselecteerde waarden toevoegen";
var removeAllValues = "Alle waarden verwijderen";
var removeSelectedValues = "Geselecteerde waarden verwijderen";
var chooseDate = "Kies een datum";
var changeDate = "Datum wijzigen";
var close = "Sluiten";
var open = "Open";
var accepted = function({
  name
}) {
  return `Accepteer de ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} moet na ${date(args[0])} zijn.`;
  }
  return `${sentence(name)} moet in de toekomst liggen.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} mag alleen alfabetische tekens bevatten.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} mag alleen letters en cijfers bevatten.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} mag alleen letters en spaties bevatten.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} moet alfabetische tekens bevatten.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} moet letters of cijfers bevatten.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} moet letters of spaties bevatten.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} moet een symbool bevatten.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} moet hoofdletters bevatten.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} moet kleine letters bevatten.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} moet cijfers bevatten.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} moet een symbool zijn.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} mag alleen hoofdletters bevatten.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} mag alleen kleine letters bevatten.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} moet vóór ${date(args[0])} vallen.`;
  }
  return `${sentence(name)} moet in het verleden liggen.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Dit veld is onjuist geconfigureerd en kan niet worden verzonden.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} moet tussen ${a} en ${b} liggen.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} komt niet overeen.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} is geen geldige datum, gebruik de notatie ${args[0]}`;
  }
  return "Dit veld is onjuist geconfigureerd en kan niet worden verzonden";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} moet tussen ${date(args[0])} en ${date(args[1])} liggen`;
};
var email = "Vul een geldig e-mailadres in.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} eindigt niet met ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} is geen toegestane waarde.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} moet minimaal één teken zijn.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} mag maximaal ${max2} tekens lang zijn.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} moet ${max2} tekens lang zijn.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} moet minimaal ${min2} tekens lang zijn.`;
  }
  return `${sentence(name)} moet tussen de ${min2} en ${max2} tekens zijn.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} is geen toegestane waarde.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Mag niet meer dan ${args[0]} ${name} hebben.`;
  }
  return `${sentence(name)} moet kleiner zijn dan of gelijk zijn aan ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Geen bestandsformaten toegestaan.";
  }
  return `${sentence(name)} moet van het type: ${args[0]} zijn`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Mag niet minder dan ${args[0]} ${name} hebben.`;
  }
  return `${sentence(name)} moet minimaal ${args[0]} zijn.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `"${value}" is geen toegestane ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} moet een getal zijn.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" of ")} is vereist.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} is verplicht.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} begint niet met ${list(args)}.`;
};
var url = function() {
  return `Voer een geldige URL in.`;
};
var invalidDate = "De geselecteerde datum is ongeldig.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var nl_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, nl_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=nl.mjs.map